import {FolderTree} from '@/vue-caas/utils/foldtree';

export class FolderTreeParser {
  constructor() {
    this.currentItemIndex = -1;
    this.preItemLevel = -1;
    this.foldItems = [];
  }

  _init(foldtbl) {
    this.foldItems = foldtbl;
    this.currentItemIndex = 0;
    this.preItemLevel = 0;
  }

  _readCurrentItem() {
    return this.foldItems[this.currentItemIndex];
  }

  _readNextItem() {
    if (this.currentItemIndex === this.foldItems.length - 1) return null;

    this.currentItemIndex += 1;
    return this.foldItems[this.currentItemIndex];
  }
  _goParent(dict) {
    if(!dict.parent) return dict.parent;
    else return dict;
  }

  parse(foldtbl) {
    this._init(foldtbl);
    const roottree = new FolderTree('0000000000', '/');
    this._doParse(this._readCurrentItem(), roottree);
    return [roottree.toJson()];
  }

  _doParse(lineitem, dict) {
    if (!lineitem) return;
    if (!dict) return;

    // console.log('-------_doParse!!--------');
    // console.log(JSON.stringify(lineitem));
    // console.log('----------------------');
    // console.log(dict.toJson());
    // console.log('----------------------');

    // User Directory는 최대 3단계까지만 만들 수 있다.
    if (lineitem.FOLD_LVL == '1')   // Root Level
    {
      let item = new FolderTree(lineitem.FOLD_ID, lineitem.FOLD_NAME, dict);
      item.name = lineitem.FOLD_NAME;
      item.level = lineitem.FOLD_LVL;
      item.parentid = lineitem.FOLD_PA_ID;
      item.foldpath = lineitem.FOLD_PATH;
      dict.addItem(item);
      this._doParse(this._readNextItem(), dict);
    }
    else if (lineitem.FOLD_LVL == '2')
    {
      this.preItemLevel = lineitem.FOLD_LVL;

      let parent_tree = dict.findItem(lineitem.FOLD_PA_ID);
      let item = new FolderTree(lineitem.FOLD_ID, lineitem.FOLD_NAME, parent_tree);
      item.name = lineitem.FOLD_NAME;
      item.level = lineitem.FOLD_LVL;
      item.parentid = lineitem.FOLD_PA_ID;
      item.foldpath = lineitem.FOLD_PATH;
      parent_tree.addItem(item);
      this._doParse(this._readNextItem(), dict);
    }
    else if (lineitem.FOLD_LVL == '3')
    {
      this.preItemLevel = lineitem.FOLD_LVL;

      dict.items.forEach((item) => {
        let parent_tree = item.findItem(lineitem.FOLD_PA_ID);
        if(parent_tree != null)
        {
          let item = new FolderTree(lineitem.FOLD_ID, lineitem.FOLD_NAME, parent_tree);
          item.name = lineitem.FOLD_NAME;
          item.level = lineitem.FOLD_LVL;
          item.parentid = lineitem.FOLD_PA_ID;
          item.foldpath = lineitem.FOLD_PATH;
          parent_tree.addItem(item);
          this._doParse(this._readNextItem(), dict);
        }
      });

    }
  }

}

// module.exports = MsgTreeParser;